import React from 'react';
import { IProps } from '../../domain/model';
import { JournalDataCreation } from '../../components/admin/journalDataCreation/journalDataCreation';

export default function JournalDataCreationPage({ state }: IProps): JSX.Element {
  return (
    <>
      {!state.loading && (
        <>
          <JournalDataCreation state={state} />
        </>
      )}
    </>
  );
}
